import type { SearchResult } from '@/services/auth/types';

// Kinds whose PreviewContent returns null. Used by both the QuickLookPanel
// "No preview" guard and isQuickLookPeekable — add here when a new kind has no preview.
export const NON_PREVIEWABLE_KINDS = new Set<SearchResult['kind']>(['navigation', 'reporting_webhook', 'cdp_out']);

export const CAMPAIGN_TYPE_LABELS: Record<string, string> = {
  triggered_broadcast: 'API-Triggered Broadcast',
  behavioral: 'Event Triggered',
  seg_attr: 'Segment Triggered',
  date: 'Date Triggered',
  form: 'Form Submitted',
  webhook: 'Webhook',
  transactional: 'Transactional',
  relationship: 'Relationship',
  object: 'Object',
  none: 'Campaign',
};

export const SEGMENT_TYPE_LABELS: Record<string, string> = {
  static: 'Manual',
  dynamic: 'Data-Driven',
  temporary: 'Temporary',
  hidden: 'Hidden',
};
